import React, { useEffect, useState } from "react";
import TextAnimation from "./layout/TextAnimation";
import MobNavbar from "../custom/MobNavbar";
import Navbar from "../custom/Navbar";
import "./Projects.css";
import My_Projects from "./My_Projects";

function Projects(props) {

  return (
    <>
      <div id="Projects" style={{backgroundColor: props.darkMode?"rgb(17 24 39)":"darkcyan"}} className="mob main-p">
        <div className="container-t">
          <My_Projects />
        </div>
      </div>

      {/* <div className="row cust-row">
          <div className="card1 col-12 col-lg-4">
            <div class="thecard">
              <div class="thefront">
                <img src="https://dengsolutions.com/deng_A478Erd/images/bank%20management.jpg" />
                <p
                  style={{
                    fontWeight: "800",
                    textAlign: "center",
                    paddingTop: "22px",
                    fontSize: "29px",
                  }}
                >
                  Bank Management
                  <br /> System
                </p>
              </div>

              <div class="theback">
                <h1>Project features:-</h1>
                <p>
                  <ul className="card-ul">
                    <li className="card-li" style={{ marginLeft: "-15px" }}>
                      👉 User can create/close an account
                    </li>
                    <li className="card-li" style={{ marginLeft: "-7px" }}>
                      👉 User can deposit/withdraw money
                      <br /> from their accounts
                    </li>
                    <li className="card-li" style={{ marginLeft: "-7px" }}>
                      👉 User can examine reports for all of their accounts
                    </li>
                    <li className="card-li">
                      👉 User can check the balance present
                      <br /> in his account
                    </li>
                    <li className="card-li" style={{ marginLeft: "-50px" }}>
                      👉 Github repo Link:-{" "}
                      <a
                        href="https://github.com/gaurav-iitb/banking-management-system"
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        Click here
                      </a>
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div> */}

      {/* card2 */}
      {/* <div className="card2 col-12 col-lg-4">
            <div class="thecard2">
              <div class="thefront2">
                <img
                  src="https://mobileit.ie/wp-content/uploads/2020/04/Spotify-4.png"
                  style={{ marginTop: "-10px" }}
                  width="300px"
                  height="235px"
                />
                <p
                  style={{
                    fontWeight: "800",
                    textAlign: "center",
                    paddingTop: "39px",
                    fontSize: "29px",
                  }}
                >
                  Spotify Clone
                </p>
              </div>

              <div class="theback2">
                <h1>Project features:-</h1>
                <p>
                  <ul className="card-ul2">
                    <li className="card-li2" style={{ marginLeft: "-17px" }}>
                      👉 User can play/pause the music.
                    </li>
                    <li className="card-li2" style={{ marginLeft: "-6px" }}>
                      👉 User can play the songs from his spotify playlists
                    </li>
                    <li className="card-li2">
                      👉 User can adjust the volume of the music.
                    </li>
                    <li className="card-li2" style={{ marginLeft: "-3px" }}>
                      👉 Used Spotify Web API for building
                      <br /> this project.
                    </li>
                    <li className="card-li2" style={{ marginLeft: "-39px" }}>
                      👉 Github repo Link:-{" "}
                      <a
                        href="https://github.com/gaurav-iitb/Spotify-clone"
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        Click here
                      </a>
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div> */}

      {/* card3 */}
      {/* <div className="card3 col-12 col-lg-4">
            <div class="thecard3">
              <div class="thefront3">
                <img src="expense.jpeg" width="300px" height="223px" />
                <p
                  style={{
                    fontWeight: "800",
                    textAlign: "center",
                    paddingTop: "39px",
                    fontSize: "29px",
                  }}
                >
                  Expense Manager
                </p>
              </div>

              <div class="theback3">
                <h1>Project features:-</h1>
                <p>
                  <ul className="card-ul3">
                    <li className="card-li3" style={{ marginLeft: "-35px" }}>
                      👉 User can add their expenses in date,title,amount
                      format.
                    </li>
                    <li className="card-li3" style={{ marginLeft: "-52px" }}>
                      👉 User can sort their expenses
                      <br /> according to year.
                    </li>
                    <li className="card-li3">
                      👉 Used React Context APIs and React Hooks while building
                      this project.
                    </li>
                    <li className="card-li3" style={{ marginLeft: "-55px" }}>
                      👉 Github repo Link:-
                      <a
                        href="https://github.com/gaurav-iitb/expense-manager"
                        style={{ color: "white", textDecoration: "none" }}
                      >
                        Click here
                      </a>
                    </li>
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </div>  */}
    </>
  );
}

export default Projects;
